import GoogleIcon from '@mui/icons-material/Google';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import {
    Autocomplete,
    Box,
    ListItemIcon,
    ListItemText,
    TextField,
    TextFieldProps,
    Tooltip,
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { UserInfo } from '../../sic-lib/types/UserConfig';
import { useAppSelector } from '../../store/hooks';

type Props = TextFieldProps & {
    onSelectHandler: React.Dispatch<{ users: string[] }>;
    usernames: string[];
};

export default function SelectUserReport({ usernames, onSelectHandler, ...props }: Props) {
    const { classes } = useStyles();

    const users = useAppSelector(state => state.user.users);

    const [confirmedUser, setConfirmedUser] = React.useState<UserInfo[]>(
        users.filter(user => usernames.some(v => v === user.userName)),
    );

    // sort function to make sure queryKey will be always in the same order to avoid unnecessary re-fetch
    const handleSelect = (event: React.SyntheticEvent, value: UserInfo[]) => {
        if (value) {
            console.log(value);
            onSelectHandler({ users: value.map(user => user.userName).sort() });
            setConfirmedUser(value);
        }
    };

    const renderOption = (props: any, option: UserInfo) => (
        <Box component="li" {...props}>
            <div className={classes.listItem}>
                <ListItemText className={classes.listItemName}>{option.userName}</ListItemText>
                <ListItemIcon>
                    {option.userEmailId && (
                        <Tooltip title={`Connected to ${option.userEmailId}`}>
                            <MailIcon fontSize="small" />
                        </Tooltip>
                    )}
                    {option.googleAccountId && (
                        <Tooltip title={`Google Account: ${option.googleAccountId}`}>
                            <GoogleIcon fontSize="small" />
                        </Tooltip>
                    )}
                    {option.twilioPhoneNumber && (
                        <Tooltip title={`Virutal Phone: ${option.twilioPhoneNumber}`}>
                            <PhoneIcon fontSize="small" />
                        </Tooltip>
                    )}
                </ListItemIcon>
            </div>
        </Box>
    );

    return (
        <>
            <Autocomplete
                disablePortal
                multiple
                fullWidth
                defaultValue={confirmedUser}
                id="user-select"
                options={users}
                getOptionLabel={option => option.userName}
                renderInput={params => (
                    <TextField {...params} sx={{ ml: 0.5 }} label="Select User" />
                )}
                noOptionsText="No user found."
                filterSelectedOptions
                renderOption={(props, option) => renderOption(props, option)}
                onChange={handleSelect}
                // onInputChange={handleChange}
            />
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    listItem: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        textAlign: 'left',
        alignItems: 'center',
        justifyContent: 'flex-start',
        textDecoration: 'none',
    },
    listItemName: {
        margin: 0,
    },
}));
